import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
import ServiceTypeIcon from "../../Icons/ServiceTypeIcon";
import RemoteAreaIcon from "../../Icons/RemoteAreaIcon";
const HublistComponent = loadable(() => import("../../components/Hub/Hublist"));
const Hublist = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <RemoteAreaIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Hub</span>
      </div>
      <HublistComponent />
    </>
  );
};

export default Hublist;
